// 云起人群
import { get, post, postJson, deleteApi, imagePost } from '../axios'

// 云起人群分页查询接口
export const getYyunQiCrowd = p => get(`/yunQiCrowd/page`, p);

// 批量删除人群接口
export const delYyunQiCrowd = p => postJson(`/yunQiCrowd/delete`, p);

// 云起人群转化生成京东人群接口
export const convertJdCrowd = p => postJson(`/yunQiCrowd/convertJdCrowd`, p);

// get
export const buildHd = p => get(`/yunQiCrowd/buildHd`, p);

// 更新动态云起人群
export const updateDynamicCrowd = p => post(`/yunQiCrowd/updateDynamicCrowd`, p);

// 云起人群复制
export const copyCrowd = p => postJson(`/yunQiCrowd/copyCrowd`, p);
